const emailConfig = {
  addTitle: '添加邮箱配置',
  editTitle: '编辑邮箱配置',
  addButton: '添加邮箱',
  dialogDesc: '常规邮箱继续使用 SMTP，Gmail 请前往右上角个人中心完成绑定。',
  subtitle: '输入邮箱后自动识别服务商，常见邮箱直接完成配置，自定义域名再补高级 SMTP 参数。',
  heroTitle: '绑定你的发信邮箱',
  heroDesc: '这里仅展示已绑定邮箱，点击右上角按钮即可新增或继续编辑。',
  pageStepBind: '绑定邮箱',
  pageStepTemplate: '添加邮件模板',
  heroStepDetect: '输入邮箱',
  heroStepAuth: '完成授权',
  heroStepDone: '保存启用',
  provider: '邮箱服务商',
  providerPlaceholder: '选择服务商自动填充配置',
  providerDetected: '已自动识别',
  providerHintIdle: '输入邮箱后会自动识别常见服务商并补全推荐配置。',
  providerManual: '可手动切换',
  providerUnknown: '未识别邮箱服务商，请手动选择',
  providerUnknownAuto: '未识别常见邮箱服务商，已为你展开高级 SMTP 选项。',
  recommendedProviders: '常用服务商',
  advancedTitle: '高级选项',
  advancedDesc: '如果你使用自定义域名邮箱或企业邮箱，可以手动填写 SMTP 参数。',
  advancedShow: '展开高级选项',
  advancedHide: '收起高级选项',
  smtpHost: 'SMTP 主机',
  smtpHostPlaceholder: '例如：smtp.your-company.com',
  smtpPort: '端口',
  smtpUsername: 'SMTP 用户名',
  smtpUsernamePlaceholder: '默认与邮箱一致，可按需修改',
  smtpSecurity: '连接加密',
  smtpSecuritySSL: 'SSL / TLS',
  smtpSecuritySTARTTLS: 'STARTTLS / 明文升级',
  smtpHostRequired: 'SMTP 主机不能为空',
  smtpPortRequired: 'SMTP 端口不能为空',
  smtpUsernameRequired: 'SMTP 用户名不能为空',
  email: '邮箱',
  emailPlaceholder: '请输入邮箱',
  nickname: '发信者名称',
  nicknamePlaceholder: '请输入发信者名称，例如：Clement Hu',
  nicknameHelper: '收件人看到的发件人名称会显示这里填写的内容。',
  nicknameRequired: '发信者名称不能为空',
  nicknameExampleButton: '示例',
  nicknameExampleAlt: '发信者名称示例',
  smtpAuthCode: 'SMTP / 密码',
  smtpAuthCodePlaceholder: '请输入邮箱密码',
  authGuideTitle: '配置说明',
  authGuideDefault: '这里填写邮箱的 SMTP 密码或服务商提供的 SMTP 授权码。',
  authGuideDetected: '已根据邮箱自动匹配服务商，你只需要确认后填写密码即可。',
  authGuideQQ: 'QQ 邮箱需先在邮箱设置里开启 SMTP，并生成独立授权码。',
  qqGuideTitle: 'QQ 邮箱 SMTP 教程',
  qqGuideDesc: 'QQ 邮箱需要先在邮箱后台开启 SMTP 服务，并生成授权码，再填写到下方输入框。',
  qqGuideOpenAction: '打开 QQ 邮箱官网',
  qqGuideStep1: '先打开 QQ 邮箱官网 https://mail.qq.com。',
  qqGuideStep2: '点击右上角“设置”。',
  qqGuideStep3: '进入左下角“账号与安全”。',
  qqGuideStep4: '打开“安全设置”。',
  qqGuideStep5: '找到并开启 SMTP 服务。',
  qqGuideStep6: '生成授权码，并将授权码填写到下方密码输入框。',
  authGuide163: '163 / 126 邮箱需在设置中开启客户端授权密码后再填写。',
  authGuideAliyun: '阿里云邮箱通常需要在管理后台开启 SMTP，并使用授权码或专用密码。',
  authGuideGmail: 'Gmail 推荐一键授权发信；如你已有 Gmail 授权码，也可直接填写后继续保存。',
  gmailBindHint: '检测到 Gmail 邮箱，可一键授权 Gmail 发信，或填写 Gmail 授权码后继续。',
  gmailAppPasswordLabel: '谷歌应用专用密码',
  gmailAppPasswordPlaceholder: '请输入谷歌应用专用密码',
  gmailAuthorizeButton: '授权 Gmail 发信',
  gmailAuthorizeCardTitle: '一键授权',
  gmailAuthorizeCardDesc: '点击后会打开 Google 授权窗口，完成授权后自动保存到后端并关闭当前弹窗。',
  gmailAuthorizePreparing: 'Gmail 授权能力准备中，后续将可直接跳转授权。',
  gmailAuthorizeOnlyForGmail: '仅 Gmail 邮箱支持一键授权，请先输入 Gmail 邮箱地址。',
  gmailConnectorMissing: '未配置 Google Connector，请联系管理员检查环境变量。',
  gmailAuthorizePopupBlocked: '浏览器拦截了授权弹窗，请允许弹窗后重试。',
  gmailAuthorizePopupOpened: '已打开 Gmail 授权窗口，请在新窗口完成授权。',
  gmailAuthorizeRequired: 'Gmail 默认使用一键授权；如需手动填写授权码，请先展开高级选项。',
  gmailAuthorizeFailed: 'Gmail 授权失败，请重试。',
  gmailAuthorizeSaveFailed: 'Gmail 授权成功，但保存邮箱配置失败，请返回后重试。',
  gmailAuthorizeStateInvalid: '授权状态已失效，请重新发起授权。',
  gmailAuthorizeSessionExpired: '授权会话已过期，请重新发起 Gmail 授权。',
  gmailGuideTitle: '手动绑定教程',
  gmailGuideStep1: '第 1 步：先完成 Google 两步验证（2FA）。',
  gmailGuideStep1Action: '去开启 2FA',
  gmailGuideStep2: '第 2 步：生成 Gmail 应用专用密码并填写到下方输入框。',
  gmailGuideStep2Action: '去生成应用专用密码',
  authGuideOutlook:
    'Outlook / Microsoft 365 需要确认 SMTP AUTH 可用，并填写应用密码或租户允许的凭据。',
  authGuideYahoo: 'Yahoo Mail 需要使用 App Password，而不是账号登录密码。',
  authGuideICloud: 'iCloud Mail 需要先生成 App 专用密码。',
  authGuideZoho: 'Zoho Mail 推荐使用应用专用密码，并确认 SMTP 服务已开启。',
  authGuideFeishu: '飞书邮箱需确认 SMTP 已启用，并使用对应授权码。',
  authGuideOther: '如果你不确定授权码来源，建议先去对应邮箱后台搜索 SMTP 或客户端授权码。',
  authHintSecure: '系统会按该服务商推荐的 SMTP 主机、端口和加密方式保存。',
  remark: '备注',
  remarkPlaceholder: '请输入备注，如：工作邮箱',
  remarkRequired: '备注不能为空',
  remarkHelper: '建议备注团队或用途，方便后续发送邮件时识别。',
  reset: '重置',
  save: '保存',
  saveAndFinish: '保存配置',
  update: '更新',
  saving: '保存中...',
  saved: '配置添加成功',
  updated: '配置更新成功',
  createFailedFriendly: '邮箱配置创建失败，请检查邮箱和授权信息后重试。',
  updateFailedFriendly: '邮箱配置更新失败，请检查邮箱和授权信息后重试。',
  selectProvider: '请选择邮箱服务商',
  listTitle: '已配置邮箱',
  listSubtitle: '管理你已添加的邮箱配置',
  refresh: '刷新',
  noData: '暂无配置，请先添加邮箱',
  configCount: '共 {count} 条配置',
  providerCol: '服务商',
  authMethodCol: '认证方式',
  authMethodOAuth: 'Google OAuth',
  authMethodSmtp: 'SMTP 凭据',
  emailRequired: '邮箱地址不能为空',
  authCodeRequired: '密码不能为空',
  formSectionTitle: '快速配置',
  formSectionDesc: '优先输入邮箱地址自动识别，识别不到时自动展开高级 SMTP 配置。',
  listSectionTitle: '已绑定邮箱',
  listSectionDesc: '你可以编辑备注、替换密码，发送邮件时会默认使用列表中的配置。',
  emptyTitle: '还没有绑定邮箱',
  emptyDesc: '先完成左侧配置，保存后即可在发送邮件时直接选择。',
  secureNote: '已使用预置 SMTP 参数',
  editMode: '当前正在编辑此邮箱配置',
  testSectionTitle: '测试发送',
  testSectionDesc: '将使用当前填写的配置发送测试邮件到该邮箱账号本身，无需先保存。',
  testTargetEmail: '测试接收邮箱',
  testTargetEmailPlaceholder: '请输入用于接收测试邮件的邮箱',
  testTargetEmailRequired: '测试接收邮箱不能为空',
  testTargetEmailInvalid: '请输入正确的测试接收邮箱',
  testSendButton: '发送测试邮件',
  testSent: '测试邮件已发送',
  testSendFailed: '测试邮件发送失败',
  testSendCheckCredentials: '测试邮件发送失败，请检查邮箱或密码是否正确',
  deleteConfirm: '删除后不可恢复，确认继续吗？',
  deleteTitle: '删除邮箱配置',
  alreadyConfigured: '已回填编辑表单',
  deleted: '已删除',
  deleteFailed: '删除失败',
  loadConfigsFailed: '加载邮箱配置失败',
  loadConfigDetailFailed: '加载配置详情失败',
  prefilledEditForm: '已回填编辑表单',
}

export default emailConfig
